
    import bg from '../../assets/img/zwsj1.png';// assets/img/zwsj1.png';
    export default{
        props: ['url'],
        name: 'vchatNodata',
        data() {
            return {};
        },
        computed: {
            src() {
                return this.url || bg;
            }
        }
    }
